const STATS = [
    { value: '100M+', label: 'Pieces mailed' },
    { value: '5,000+', label: 'Trusted customers' },
    { value: '2-day', label: 'Production available' },
    { value: '★ 5.0', label: 'Customer rating' },
]

export default function SocialProof() {
    return (
        <section className="border-y border-[color-mix(in_oklab,_#1f2937_10%,_transparent)] bg-[#FFF7EC]">
            <div className="mx-auto flex max-w-7xl flex-col items-start gap-5 px-6 py-6 lg:items-center lg:px-8 lg:py-7">
                <span
                    className="text-left text-xs font-semibold uppercase text-[color-mix(in_oklab,_#3F454F_55%,_transparent)] lg:text-center"
                    style={{ letterSpacing: '0.18em' }}>
                    Trusted by real estate investors across the U.S.
                </span>
                <div className="flex w-full flex-row flex-wrap items-center justify-start gap-x-10 gap-y-4 lg:justify-center lg:gap-x-14">
                    {STATS.map((stat, i) => (
                        <div
                            key={i}
                            className="flex flex-row items-baseline gap-2">
                            <span className="text-2xl font-bold tracking-tight text-[#3F454F] lg:text-3xl">
                                {stat.value}
                            </span>
                            <span className="text-sm text-[color-mix(in_oklab,_#3F454F_65%,_transparent)]">
                                {stat.label}
                            </span>
                        </div>
                    ))}
                    <div className="basis-full flex flex-row items-center gap-2.5 lg:basis-auto">
                        <div
                            className="flex h-10 w-10 flex-col items-center justify-center rounded-lg text-white font-black leading-none"
                            style={{
                                background:
                                    'linear-gradient(to bottom right, #ED5C2F, #F28230)',
                                boxShadow: '0 2px 6px rgba(237,92,47,0.28)',
                            }}>
                            <span className="text-xs font-black">INC</span>
                        </div>
                        <span className="text-sm font-bold tracking-tight text-[#3F454F]">
                            Inc. 5000
                        </span>
                    </div>
                </div>
            </div>
        </section>
    )
}
